import styled from '@emotion/styled';
import React from 'react';

import TabBar from '#/TabBar';
import TabBarItem from '#/TabBar/Item';
import {
  LeftFade,
  RightFade,
  ScrollWidthExtenderLeft,
  ScrollWidthExtenderRight,
} from '#/TabBar/styles';

export const StyledCasusTabBar = styled(TabBar as React.ComponentType<object>)`
  ${LeftFade} {
    background: linear-gradient(90deg, var(--color-core-primary), transparent);
  }

  ${RightFade} {
    background: linear-gradient(90deg, transparent, var(--color-core-primary));
  }

  ${ScrollWidthExtenderLeft} {
    border-bottom: none;
  }

  ${ScrollWidthExtenderRight} {
    border-bottom: none;
  }
`;

export const StyledCasusTabBarItem = styled(
  TabBarItem as React.ComponentType<object>
)<{active?: boolean}>`
  border-top-left-radius: 2px;
  background-color: ${({active}): string =>
    active ? 'var(--color-core-white)' : 'var(--color-core-primary)'};
  color: ${({active}): string =>
    active ? 'var(--color-core-link)' : 'var(--color-core-white)'};
  border: var(--regular-border-width) solid
    ${({active}): string =>
      active ? 'transparent' : 'var(--color-core-grey-light)'};
  border-bottom: none;
  height: 32px;

  &:not(:first-of-type)::after {
    display: none;
  }
` as unknown as typeof TabBarItem;
